/**
 * * Runs the fetch
 */
export const fetchUsers = (url: string) => fetch(url)